/**
 * Поля табличного блока (data-type=11): мультивыбор "несколько из списка", нативный select с шевроном.
 */

function clearPanelFloatStyles(panel) {
  panel.style.cssText = '';
}

function applyPanelFixedPosition(panel, toggleBtn) {
  const trigger = toggleBtn.querySelector('.custom-table-ms__trigger');

  if (!trigger) {
    return;
  }

  const rect = trigger.getBoundingClientRect();
  const margin = 4;
  const pad = 8;
  const viewportH = window.innerHeight;
  const viewportW = window.innerWidth;
  const spaceBelow = viewportH - rect.bottom - margin;
  const spaceAbove = rect.top - margin;
  let maxH = Math.min(220, Math.max(100, spaceBelow));
  let top = rect.bottom + margin;

  if (spaceBelow < 72 && spaceAbove > spaceBelow) {
    maxH = Math.min(220, Math.max(100, spaceAbove));
    top = rect.top - margin - maxH;

    if (top < pad) {
      maxH = Math.max(80, maxH - (pad - top));
      top = pad;
    }
  }

  let left = rect.left;
  let width = rect.width;

  if (left + width > viewportW - pad) {
    left = viewportW - width - pad;
  }

  if (left < pad) {
    left = pad;
  }

  panel.style.position = 'fixed';
  panel.style.top = `${String(top)}px`;
  panel.style.left = `${String(left)}px`;
  panel.style.width = `${String(width)}px`;
  panel.style.right = 'auto';
  panel.style.marginTop = '0';
  panel.style.maxHeight = `${String(maxH)}px`;
  panel.style.zIndex = '10050';
}

function closeAllTableMultiselects() {
  document
    .querySelectorAll('.custom_work_field[data-type="11"] .custom-table-ms__panel')
    .forEach((p) => {
      p.classList.remove('is-open');
      clearPanelFloatStyles(p);
    });

  document
    .querySelectorAll('.custom_work_field[data-type="11"] .custom-table-ms__toggle-btn')
    .forEach((b) => b.setAttribute('aria-expanded', 'false'));
}

function repositionOpenTableMultiselect() {
  const open = document.querySelector('.custom_work_field[data-type="11"] .custom-table-ms__panel.is-open');

  if (!open || !open.id) {
    return;
  }

  const field = open.closest('.custom_work_field[data-type="11"]');
  const btn = field?.querySelector(`.custom-table-ms__toggle-btn[data-panel="${CSS.escape(open.id)}"]`);

  if (btn) {
    applyPanelFixedPosition(open, btn);
  }
}

function updateMultiselectLabel(panel) {
  const root = panel.closest('.custom-table-ms');

  if (!root) {
    return;
  }

  const span = root.querySelector('.custom-table-ms__label');

  if (!span) {
    return;
  }

  const placeholder = span.getAttribute('data-placeholder') || 'Выберите варианты';
  const checked = panel.querySelectorAll('input.work-column-value:checked');

  if (!checked.length) {
    span.textContent = placeholder;
    span.classList.add('custom-table-ms__label--placeholder');

    return;
  }

  const labels = [];

  checked.forEach((cb) => {
    const lab = cb.closest('label');

    if (lab) {
      const text = lab.textContent.replace(/\s+/g, ' ').trim();
      labels.push(text);
    }
  });

  span.classList.remove('custom-table-ms__label--placeholder');
  span.textContent =
    labels.length > 2 ? `Выбрано: ${String(labels.length)}` : labels.join(', ');
}

let tableNativeSelectCaretBound = false;

/** Поддержка select:open (Chromium-браузеры; иначе — эвристика toggle). */
let selectOpenPseudoCapableCache = null;

function canTrustSelectOpenPseudo() {
  if (selectOpenPseudoCapableCache !== null) {
    return selectOpenPseudoCapableCache;
  }

  selectOpenPseudoCapableCache = false;

  try {
    if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') {
      selectOpenPseudoCapableCache = CSS.supports('selector(select:open)') === true;
    }
  } catch (_) {
    selectOpenPseudoCapableCache = false;
  }

  return selectOpenPseudoCapableCache;
}

/** Класс `--open` в соответствии с фактическим состоянием списка (псевдокласс :open). */
function syncNativeSelectCaretFromDom(select) {
  const wrap = select.closest('.custom-table-native-select');

  if (!wrap || !canTrustSelectOpenPseudo()) {
    return false;
  }

  try {
    wrap.classList.toggle('custom-table-native-select--open', select.matches(':open'));

    return true;
  } catch (_) {
    selectOpenPseudoCapableCache = false;

    return false;
  }
}

function bounceSyncNativeSelectOpen(select, pollMs) {
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      if (!syncNativeSelectCaretFromDom(select)) {
        return;
      }

      if (pollMs > 0) {
        pollNativeSelectOpenState(select, pollMs);
      }
    });
  });
}

/** Несколько кадров после клика/клавиши — нативное открытие не всегда обновляет :open в том же такте. */
function pollNativeSelectOpenState(select, durationMs) {
  if (!canTrustSelectOpenPseudo()) {
    return;
  }

  const wrap = select.closest('.custom-table-native-select');

  if (!wrap) {
    return;
  }

  const t0 = performance.now();

  function frame() {
    if (!syncNativeSelectCaretFromDom(select)) {
      return;
    }

    if (performance.now() - t0 < durationMs) {
      requestAnimationFrame(frame);
    }
  }

  frame();
}

/** Нативный select: где возможно — читаем состояние из :open, иначе toggle + сбросы. */
function bindTableNativeSelectCaret() {
  if (tableNativeSelectCaretBound) {
    return;
  }

  tableNativeSelectCaretBound = true;

  const tableSelector = '.custom_work_field[data-type="11"]';
  const selectInTable = `${tableSelector} .custom-table-native-select select.work-column-value`;

  function getTableNativeSelect(target) {
    return target?.closest?.(selectInTable) ?? null;
  }

  document.addEventListener(
    'pointerdown',
    function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) {
        return;
      }

      const select = getTableNativeSelect(e.target);

      if (!select) {
        return;
      }

      const wrap = select.closest('.custom-table-native-select');

      if (canTrustSelectOpenPseudo()) {
        bounceSyncNativeSelectOpen(select, 650);
      } else {
        wrap?.classList.toggle('custom-table-native-select--open');
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      const select = getTableNativeSelect(e.target);

      if (!select || !canTrustSelectOpenPseudo()) {
        return;
      }

      bounceSyncNativeSelectOpen(select, 400);
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (e) {
      const t = e.target;

      if (!(t instanceof HTMLSelectElement) || !t.classList.contains('work-column-value') || !t.closest(tableSelector)) {
        return;
      }

      if (!t.closest('.custom-table-native-select')) {
        return;
      }

      if (canTrustSelectOpenPseudo()) {
        bounceSyncNativeSelectOpen(t, 200);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (e) {
      const t = e.target;

      if (!(t instanceof HTMLSelectElement) || !t.classList.contains('work-column-value') || !t.closest(tableSelector)) {
        return;
      }

      const wrap = t.closest('.custom-table-native-select');

      if (!wrap) {
        return;
      }

      if (canTrustSelectOpenPseudo()) {
        requestAnimationFrame(function () {
          syncNativeSelectCaretFromDom(t);
        });
      } else {
        wrap.classList.remove('custom-table-native-select--open');
      }
    },
    true
  );

  document.addEventListener(
    'blur',
    function (e) {
      const t = e.target;

      if (!(t instanceof HTMLSelectElement) || !t.classList.contains('work-column-value') || !t.closest(tableSelector)) {
        return;
      }

      const wrap = t.closest('.custom-table-native-select');

      if (!wrap) {
        return;
      }

      requestAnimationFrame(function () {
        if (canTrustSelectOpenPseudo()) {
          syncNativeSelectCaretFromDom(t);

          return;
        }

        wrap.classList.remove('custom-table-native-select--open');
      });
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (e) {
      const t = e.target;

      if (!(t instanceof HTMLSelectElement) || !t.classList.contains('work-column-value') || !t.closest(tableSelector)) {
        return;
      }

      const wrap = t.closest('.custom-table-native-select');

      if (!wrap) {
        return;
      }

      if (canTrustSelectOpenPseudo()) {
        const keysPoll = ['ArrowDown', 'ArrowUp', 'Enter', ' ', 'Escape'];

        if (keysPoll.includes(e.key)) {
          bounceSyncNativeSelectOpen(t, e.key === 'Escape' ? 200 : 500);
        }

        return;
      }

      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        requestAnimationFrame(function () {
          wrap.classList.add('custom-table-native-select--open');
        });
      }

      if (e.key === 'Escape') {
        requestAnimationFrame(function () {
          wrap.classList.remove('custom-table-native-select--open');
        });
      }
    },
    true
  );
}

let tableMultiselectUiBound = false;

function bindTableMultiselectViewportListeners() {
  if (tableMultiselectUiBound) {
    return;
  }

  tableMultiselectUiBound = true;
  window.addEventListener('resize', repositionOpenTableMultiselect);
  document.addEventListener('scroll', repositionOpenTableMultiselect, true);

  document.querySelectorAll('.custom-table-work-field__scroll').forEach((el) => {
    if (el.dataset.tableMultiselectScrollBound === '1') {
      return;
    }

    el.dataset.tableMultiselectScrollBound = '1';
    el.addEventListener('scroll', repositionOpenTableMultiselect, { passive: true });
  });
}

export function refreshCustomTableMultiselectLabels() {
  document
    .querySelectorAll('.custom_work_field[data-type="11"] .custom-table-ms__panel')
    .forEach(updateMultiselectLabel);

  document.querySelectorAll('.custom-table-work-field__scroll').forEach((el) => {
    if (el.dataset.tableMultiselectScrollBound === '1') {
      return;
    }

    el.dataset.tableMultiselectScrollBound = '1';
    el.addEventListener('scroll', repositionOpenTableMultiselect, { passive: true });
  });
}

export default function initCustomTableMultiselect() {
  bindTableNativeSelectCaret();
  bindTableMultiselectViewportListeners();
  refreshCustomTableMultiselectLabels();

  document.addEventListener(
    'change',
    function (e) {
      const t = e.target;

      if (!(t.closest && t.closest('.custom-table-ms__panel'))) {
        return;
      }

      if (!t.classList.contains('work-column-value') || t.type !== 'checkbox') {
        return;
      }

      const panel = t.closest('.custom-table-ms__panel');

      if (panel) {
        updateMultiselectLabel(panel);
      }
    },
    true
  );

  document.addEventListener('click', function (e) {
    const toggleBtn = e.target.closest('.custom-table-ms__toggle-btn');

    if (toggleBtn && toggleBtn.closest('.custom_work_field[data-type="11"]')) {
      e.preventDefault();
      const panelId = toggleBtn.getAttribute('data-panel');
      const panel = panelId ? document.getElementById(panelId) : null;

      if (!panel) {
        return;
      }

      const wasOpen = panel.classList.contains('is-open');
      const willOpen = !wasOpen;

      closeAllTableMultiselects();

      if (willOpen) {
        panel.classList.add('is-open');
        toggleBtn.setAttribute('aria-expanded', 'true');
        applyPanelFixedPosition(panel, toggleBtn);
      }

      return;
    }

    if (!e.target.closest('.custom-table-ms')) {
      closeAllTableMultiselects();
    }
  });
}
